import React from 'react'
import PropTypes from 'prop-types'
import {
  ClassHeaderWrapper,
  ContentWrapper,
  TitleWrapper,
} from './component.styles'

// Export shared layout components for use in context-specific headers
export { ContentWrapper, TitleWrapper }

/**
 * Layout component for class drawer headers.
 * Provides the base wrapper structure and styling without any context-specific logic.
 * Context-specific headers should use this component and render their full content structure as children.
 *
 * The Layout only provides the ClassHeaderWrapper - headers are responsible for their own
 * internal structure (ContentWrapper, TitleWrapper, ProgressContainer, etc.)
 *
 * @param {Object} props
 * @param {boolean} props.fixedTop - Whether the header should be fixed to top
 * @param {boolean} props.fixedView - Whether the header is in fixed view mode
 * @param {React.ReactNode} props.children - Full header content structure to render
 */
const ClassDrawerHeaderLayout = ({ fixedTop, fixedView, children }) => {
  return (
    <ClassHeaderWrapper fixedTop={fixedTop} fixedView={fixedView}>
      {children}
    </ClassHeaderWrapper>
  )
}

ClassDrawerHeaderLayout.propTypes = {
  children: PropTypes.node.isRequired,
  fixedTop: PropTypes.bool,
  fixedView: PropTypes.bool,
}

export default ClassDrawerHeaderLayout
